import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-75651b80")

_pushScopeId("data-v-75651b80")
const _hoisted_1 = { class: "kn-page kn-width-full-with-menu" }
const _hoisted_2 = { class: "kn-page-content p-grid p-m-0" }
const _hoisted_3 = { class: "kn-list--column p-col-4 p-sm-4 p-md-3 p-p-0" }
const _hoisted_4 = { class: "p-col-8 p-sm-8 p-md-9 p-p-0 p-m-0 kn-page" }
const _hoisted_5 = { class: "kn-page-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_KnFabButton = _resolveComponent("KnFabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_KnListBox = _resolveComponent("KnListBox")
  const _component_KnHint = _resolveComponent("KnHint")
  const _component_Button = _resolveComponent("Button")
  const _component_DetailFormTab = _resolveComponent("DetailFormTab")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_RolesTab = _resolveComponent("RolesTab")
  const _component_UserAttributesForm = _resolveComponent("UserAttributesForm")
  const _component_TabView = _resolveComponent("TabView")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
          start: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.usersManagement.title')), 1)
          ]),
          end: _withId(() => [
            _createVNode(_component_KnFabButton, {
              icon: "fas fa-plus",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showForm())),
              "data-test": "open-form-button"
            })
          ]),
          _: 1
        }),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              class: "kn-progress-bar",
              "data-test": "progress-bar"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_KnListBox, {
          options: _ctx.users,
          settings: _ctx.usersManagementDescriptor.knListSettings,
          onClick: _ctx.onUserSelect,
          onDelete: _withModifiers(_ctx.onUserDelete, ["stop"])
        }, null, 8, ["options", "settings", "onClick", "onDelete"])
      ]),
      (_ctx.hiddenForm)
        ? (_openBlock(), _createBlock(_component_KnHint, {
            key: 0,
            title: 'managers.usersManagement.title',
            hint: 'managers.usersManagement.hint'
          }, null, 8, ["title", "hint"]))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode("div", _hoisted_4, [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
          start: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.userDetailsForm.userId), 1)
          ]),
          end: _withId(() => [
            _createVNode(_component_Button, {
              icon: "pi pi-save",
              class: "p-button-text p-button-rounded p-button-plain",
              disabled: !_ctx.dirty || !_ctx.passwordValidation,
              onClick: _ctx.saveUser
            }, null, 8, ["disabled", "onClick"]),
            _createVNode(_component_Button, {
              class: "p-button-text p-button-rounded p-button-plain",
              icon: "pi pi-times",
              onClick: _ctx.closeForm
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              class: "kn-progress-bar",
              "data-test": "progress-bar"
            }))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_TabView, {
            class: "tabview-custom kn-tab",
            ref: "usersFormTab"
          }, {
            default: _withId(() => [
              _createVNode(_component_TabPanel, null, {
                header: _withId(() => [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('managers.usersManagement.detail')), 1)
                ]),
                default: _withId(() => [
                  (!_ctx.hiddenForm)
                    ? (_openBlock(), _createBlock(_component_DetailFormTab, {
                        key: 0,
                        formInsert: _ctx.formInsert,
                        formValues: _ctx.userDetailsForm,
                        vobj: _ctx.v$,
                        disabledUID: _ctx.disableUsername,
                        onDataChanged: _ctx.onDataChange,
                        onUnlock: _cache[2] || (_cache[2] = ($event: any) => (_ctx.unlockUser($event)))
                      }, null, 8, ["formInsert", "formValues", "vobj", "disabledUID", "onDataChanged"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_TabPanel, null, {
                header: _withId(() => [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('managers.usersManagement.roles')), 1)
                ]),
                default: _withId(() => [
                  _createVNode(_component_RolesTab, {
                    defRole: _ctx.defaultRole,
                    rolesList: _ctx.roles,
                    selected: _ctx.selectedRoles,
                    onChanged: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setSelectedRoles($event))),
                    onSetDefaultRole: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setDefaultRoleValue($event)))
                  }, null, 8, ["defRole", "rolesList", "selected"])
                ]),
                _: 1
              }),
              _createVNode(_component_TabPanel, null, {
                header: _withId(() => [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('managers.usersManagement.attributes')), 1)
                ]),
                default: _withId(() => [
                  _createVNode(_component_UserAttributesForm, {
                    attributes: _ctx.attributes,
                    modelValue: _ctx.attributesForm,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.attributesForm = $event)),
                    onFormDirty: _ctx.onFormDirty
                  }, null, 8, ["attributes", "modelValue", "onFormDirty"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512)
        ])
      ], 512), [
        [_vShow, !_ctx.hiddenForm]
      ])
    ])
  ]))
})